export const CAN_VIEW_SETTINGS_PAGE = 'canViewSettingsPage';
export const CAN_MANAGE_REPORTS = 'canManageReports';
